'use strict'

import Helper from '@/utils/helper'

const SCREEN_DEFAULT_TIMEOUT = 50

class TimeoutsManager {
  constructor () {
    this.screens = {
      default: SCREEN_DEFAULT_TIMEOUT
    }

    this.dialogs = null
  }

  init (config) {
    if (Helper.isDefined(config)) {
      if (Helper.isDefined(config.screens)) {
        this.setScreens(config.screens)
      }

      if (Helper.isDefined(config.dialogs)) {
        this.setDialogs(config.dialogs)
      }
    }
  }

  setScreens (screens) {
    this.screens.default = Helper.getValue(screens.default, SCREEN_DEFAULT_TIMEOUT)
  }

  setDialogs (dialogs) {
    this.dialogs = Helper.getValue(dialogs)
  }

  getScreenDefaultTimeout () {
    return this.screens.default
  }
}

export default new TimeoutsManager()
